<template>
  <!-- 筛选 -->
  <div class="search-filter-area">
    <div class="filter-title">{{ title }}</div>
    <div
      class="filter-words-block"
      :style="[{ height: extended ? 'auto' : '50px' }]"
    >
      <div class="element" :ref="`ele${title}`">
        <div
          class="filter-item not-limit"
          :class="{ active: !selectArray.length }"
          @click="reset"
        >
          不限
        </div>
        <!-- 筛选词 -->
        <div
          class="filter-item"
          :class="{ active: judgeStatus(item) }"
          v-for="(item, index) of dataSource"
          :key="index"
          @click="selectHandle(item)"
        >
          {{ item }}
        </div>
        <div
          class="filter-extend"
          :class="{ extended }"
          v-show="couldExtend"
          @click="extended = !extended"
        >
          更多<i class="el-icon-plus"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @description search-filter --- 筛选搜索
 * @property {String} title 筛选标题
 * @property {Array} dataSource 筛选条件
 * @property {Number} screenWidth 屏幕宽度
 * @event {Function} select 选择事件
 */
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    dataSource: {
      type: Array,
      default: function () {
        return [];
      },
    },
    screenWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectArray: [], // 选中的筛选项
      extended: false, // 是否显示更多
      couldExtend: false, // 是否有更多（是否能显示多行）
    };
  },
  watch: {
    dataSource() {
      this.$nextTick(() => {
        let ele = this.$refs[`ele${this.title}`];
        this.couldExtend = ele ? ele.offsetHeight > 100 : false;
      });
    },
    screenWidth() {
      this.$nextTick(() => {
        let ele = this.$refs[`ele${this.title}`];
        // console.log(ele.offsetHeight, `ele${this.title}`);
        this.couldExtend = ele ? ele.offsetHeight > 100 : false;
      });
    },
  },
  methods: {
    // 判断是否选中
    judgeStatus(_value) {
      return this.selectArray.indexOf(_value) !== -1;
    },
    selectHandle(_item) {
      let value = _item;
      let selected = this.judgeStatus(value);
      if (selected) {
        this.selectArray = this.selectArray.filter((t) => t !== value);
      } else {
        this.selectArray.push(value);
      }
      this.$emit("search");
    },
    reset() {
      if (!this.selectArray.length) return;
      this.selectArray = [];
      this.$emit("search");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.search-filter-area {
  display: flex;
  border: 1px solid #d6d6d6;
  overflow: hidden;

  &:not(:last-of-type) {
    border-bottom: none;
  }
}

// 左侧筛选标题
.filter-title {
  width: 90px;
  line-height: 48px;
  background: #f3f3f3;
  text-align: center;
  font-size: 14px;
  color: @text-color-base;
  box-shadow: 0px 0px 15px 0px #eaeeff;
}

// 筛选词集合
.filter-words-block {
  position: relative;
  height: 48px;
  flex: 1;
  align-self: center;
  padding: 0 100px 0 20px;
  background: #ffffff;
}

.element{
  padding: 12px 0;
}

// 单个筛选词
.filter-item {
  display: inline-block;
  max-width: 140px;
  height: 24px;
  line-height: 24px;
  // margin: 13px 10px 13px 0;
  padding: 0 12px;
  font-size: 14px;
  color: @text-color-base;
  border: 1px solid transparent;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  margin-bottom: 5px;

  &.not-limit.active {
    cursor: default;
  }

  &.active {
    position: relative;
    border-color: @a-color-active;

    &::after {
      content: "";
      display: block;
      width: 10px;
      height: 12px;
      position: absolute;
      bottom: -1px;
      right: 0;
      background-image: url(/@/assets/images/search/filter-selected.png);
      background-size: 10px 12px;
    }
  }
}

// 更多
.filter-extend {
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  position: absolute;
  top: 10px;
  right: 20px;
  border: 1px solid #cfcece;
  font-size: 12px;
  color: #9f9e9e;
  text-align: center;
  cursor: pointer;

  i {
    margin-left: 4px;
  }

  &:hover {
    border-color: #dc000095;
    color: #dc000095;
  }

  &.extended {
    border-color: #dc0000;
    color: #dc0000;
    transition: all 0.2s;
  }
}
</style>
